(() => {
  const ACTIVE_CLASS = 'is-visible';
  const BOTTOM_CLASS = 'is-bottom';
  const WRAP_SELECTOR = '.cart-item__preorder-icon-wrap';
  const TOOLTIP_SELECTOR = '.cart-item__preorder-tooltip';
  const OFFSET = 8;
  const VIEWPORT_PADDING = 8;

  let activeWrap = null;
  let activeTooltip = null;

  function getTooltipFromWrap(wrap) {
    return wrap ? wrap.querySelector(TOOLTIP_SELECTOR) : null;
  }

  function hideActiveTooltip() {
    if (!activeTooltip) return;
    activeTooltip.classList.remove(ACTIVE_CLASS);
    activeTooltip.classList.remove(BOTTOM_CLASS);
    activeTooltip.style.left = '';
    activeTooltip.style.maxWidth = '';
    activeWrap = null;
    activeTooltip = null;
  }

  function getBoundsRect(wrap, viewportWidth, viewportHeight) {
    const roots = [
      wrap.closest('.order-detail__product'),
      wrap.closest('.drawer__content'),
      wrap.closest('cart-items')
    ].filter(Boolean);

    const viewportRect = { left: 0, top: 0, right: viewportWidth, bottom: viewportHeight };
    if (!roots.length) return viewportRect;

    const rootRect = roots[0].getBoundingClientRect();
    return {
      left: Math.max(viewportRect.left, rootRect.left),
      top: Math.max(viewportRect.top, rootRect.top),
      right: Math.min(viewportRect.right, rootRect.right),
      bottom: Math.min(viewportRect.bottom, rootRect.bottom)
    };
  }

  function positionTooltip(wrap, tooltip) {
    const preorderCell = wrap.closest('.cart-item__preorder') || wrap;
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;
    const boundsRect = getBoundsRect(wrap, viewportWidth, viewportHeight);
    const wrapRect = wrap.getBoundingClientRect();
    const preorderRect = preorderCell.getBoundingClientRect();

    // Keep width within visible bounds to avoid clipping.
    const visibleWidth = Math.max(120, Math.floor(boundsRect.right - boundsRect.left - (VIEWPORT_PADDING * 2)));
    const cappedMaxWidth = Math.min(320, visibleWidth);
    tooltip.style.maxWidth = `${cappedMaxWidth}px`;
    tooltip.style.left = '50%';
    tooltip.classList.remove(BOTTOM_CLASS);

    // One measurement pass after size settles.
    const tooltipRect = tooltip.getBoundingClientRect();

    // Center by preorder cell (not icon wrap), then clamp to visible bounds.
    const preorderCenterX = preorderRect.left + (preorderRect.width / 2);
    const centeredLeftInWrap = preorderCenterX - wrapRect.left - (tooltipRect.width / 2);
    const minLeftInWrap = (boundsRect.left - wrapRect.left) + VIEWPORT_PADDING;
    const maxLeftInWrap = (boundsRect.right - wrapRect.left) - tooltipRect.width - VIEWPORT_PADDING;
    const clampedLeftInWrap = Math.max(minLeftInWrap, Math.min(centeredLeftInWrap, maxLeftInWrap));
    tooltip.style.left = `${Math.round(clampedLeftInWrap)}px`;
    tooltip.style.transform = 'none';

    // Flip to bottom only when top side does not have enough space.
    const topSpace = preorderRect.top - boundsRect.top;
    if (topSpace < tooltipRect.height + OFFSET + VIEWPORT_PADDING) {
      tooltip.classList.add(BOTTOM_CLASS);
    } else {
      tooltip.classList.remove(BOTTOM_CLASS);
    }
  }

  function showTooltip(wrap) {
    const tooltip = getTooltipFromWrap(wrap);
    if (!tooltip) return;
    if (activeWrap && activeWrap !== wrap) hideActiveTooltip();
    tooltip.classList.add(ACTIVE_CLASS);
    activeWrap = wrap;
    activeTooltip = tooltip;
    requestAnimationFrame(() => positionTooltip(wrap, tooltip));
  }

  function handleMouseOver(evt) {
    const wrap = evt.target.closest(WRAP_SELECTOR);
    if (!wrap) return;
    showTooltip(wrap);
  }

  function handleMouseOut(evt) {
    if (!activeWrap) return;
    if (activeWrap.contains(evt.relatedTarget)) return;
    hideActiveTooltip();
  }

  function handleFocusIn(evt) {
    const wrap = evt.target.closest(WRAP_SELECTOR);
    if (!wrap) return;
    showTooltip(wrap);
  }

  function handleFocusOut(evt) {
    if (!activeWrap) return;
    if (activeWrap.contains(evt.relatedTarget)) return;
    hideActiveTooltip();
  }

  function repositionActive() {
    if (!activeWrap || !activeTooltip) return;
    positionTooltip(activeWrap, activeTooltip);
  }

  document.addEventListener('mouseover', handleMouseOver);
  document.addEventListener('mouseout', handleMouseOut);
  document.addEventListener('focusin', handleFocusIn);
  document.addEventListener('focusout', handleFocusOut);
  window.addEventListener('resize', repositionActive, { passive: true });
})();
